/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SearchLogsPayload,
  SearchLogsPayload$Outbound,
  SearchLogsPayload$outboundSchema,
} from "../components/searchlogspayload.js";

export type SearchLogsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type SearchLogsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type SearchLogsSecurity = {
  option1?: SearchLogsSecurityOption1 | undefined;
  option2?: SearchLogsSecurityOption2 | undefined;
};

export type SearchLogsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  searchLogsPayload: SearchLogsPayload;
};

/** @internal */
export type SearchLogsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const SearchLogsSecurityOption1$outboundSchema: z.ZodMiniType<
  SearchLogsSecurityOption1$Outbound,
  SearchLogsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function searchLogsSecurityOption1ToJSON(
  searchLogsSecurityOption1: SearchLogsSecurityOption1,
): string {
  return JSON.stringify(
    SearchLogsSecurityOption1$outboundSchema.parse(searchLogsSecurityOption1),
  );
}

/** @internal */
export type SearchLogsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const SearchLogsSecurityOption2$outboundSchema: z.ZodMiniType<
  SearchLogsSecurityOption2$Outbound,
  SearchLogsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function searchLogsSecurityOption2ToJSON(
  searchLogsSecurityOption2: SearchLogsSecurityOption2,
): string {
  return JSON.stringify(
    SearchLogsSecurityOption2$outboundSchema.parse(searchLogsSecurityOption2),
  );
}

/** @internal */
export type SearchLogsSecurity$Outbound = {
  Option1?: SearchLogsSecurityOption1$Outbound | undefined;
  Option2?: SearchLogsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const SearchLogsSecurity$outboundSchema: z.ZodMiniType<
  SearchLogsSecurity$Outbound,
  SearchLogsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(z.lazy(() => SearchLogsSecurityOption1$outboundSchema)),
    option2: z.optional(z.lazy(() => SearchLogsSecurityOption2$outboundSchema)),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function searchLogsSecurityToJSON(
  searchLogsSecurity: SearchLogsSecurity,
): string {
  return JSON.stringify(
    SearchLogsSecurity$outboundSchema.parse(searchLogsSecurity),
  );
}

/** @internal */
export type SearchLogsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SearchLogsPayload: SearchLogsPayload$Outbound;
};

/** @internal */
export const SearchLogsRequest$outboundSchema: z.ZodMiniType<
  SearchLogsRequest$Outbound,
  SearchLogsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    searchLogsPayload: SearchLogsPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      searchLogsPayload: "SearchLogsPayload",
    });
  }),
);

export function searchLogsRequestToJSON(
  searchLogsRequest: SearchLogsRequest,
): string {
  return JSON.stringify(
    SearchLogsRequest$outboundSchema.parse(searchLogsRequest),
  );
}
